import { useState } from 'react'
import { apiCallable } from '@/lib/api'
import { getTimezonePreference, setTimezone as saveTimezone, getTimezone } from '@/lib/dateTime'

export function useTimezone() {
  const [timezone, setTimezoneState] = useState(getTimezonePreference)

  const setTimezone = (tz: string) => {
    saveTimezone(tz)
    setTimezoneState(tz)

    // Persist the resolved IANA timezone to the user's Firestore profile
    // so server-side features (e.g. Telegram alerts) can use it.
    const resolvedTz = tz === 'browser' ? getTimezone() : tz
    const updateUserTimezone = apiCallable('updateUserTimezone')
    updateUserTimezone({ timezone: resolvedTz }).catch((err) => {
      console.error('Failed to save timezone to profile:', err)
    })

    window.location.reload()
  }

  return { timezone, setTimezone }
}
